import { styled } from '@mui/material/styles'
import { Box, ListItemText, Icon, Avatar, Menu, Tooltip } from '@mui/material'

export const ToolbarStyled = styled(Box)(`
  justify-content: space-between;
  display: flex;
  min-height: 60px;
  padding: 0 30px;
  align-items: center;
  margin:left: 10px;
`)

export const DashboardNavbarRoot = styled(Box)(`
  position: static;
  border-bottom: 1px solid #EEEEEE;
`)

export const AvatarIcon = styled(Avatar)(`
  height: 40px;
  width: 40px;
  background: #F1F6FF;
  color: #242424;
  font-weight: bold;
`)

export const MenuWrapper = styled(Menu)(`
  margin-top:-20px;
  margin-left:20px;
  padding:0px;
  overflow: visible;

  &:before {
    content: '';
    position: absolute;
    bottom: 30px;
    left: 20px;
    width:0; height:0;
    border: 10px solid transparent;
    border-right: 10px solid #FFFFFF;
    border-width: 10px 14px;
    z-index: 1;
  }

  & > .MuiPaper-root.MuiPaper-elevation {
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.16);
    border-radius: 4px;
    padding:12px;
    margin-top: 24px;
  }
  & ul {
    padding:0;
  }
`)

export const BorderWrapper = styled(Box)(`
  border: 1px #D8D8D6 solid;
  padding: 16px;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: baseline;

  & > div {
    margin-top:0;
    padding-bottom:12px;
    border-bottom: 1px #E7E7E6 solid;
    margin-bottom:5px;

    & span { font-size: 19px; font-weight: 400;}
  }
  & > button {
    width: calc(100% + 20px);
    transform: translateX(-10px);
    justify-content: start;
  }
`)

export const AvatarWrapper = styled(Box)(`
  & > div {
    border: 1px solid #636363; 
    height:36px;
    width:36px;
    border-radius: 36px;
    cursor: pointer;
    font-size: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    background-color: #8B8B89;
    font-weight: 600;
    color:#fff;

    &:hover {
      background-color: black;
    }
  }

`)

export const ListItemTextNew = styled(ListItemText)(`
  span {
    color: #545454;
  }
  p {
    color: #242424;
  }
`)

export const IconWrapper = styled(Icon)(`
  width: unset !important;
  line-height: 0.8em;
`)

export const SelectCircularProgressWrapper = styled(Box)(`
  margin-bottom: -5px;
`)

export const SelectRenderValueWrapper = styled(Box)(`
  display: flex;
`)

export const SelectRenderValueText = styled(Box)(`
  margin-left: 5px;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 25px;
  letter-spacing: 0.2px;
  color: #536082;
`)

/*
export const TooltipWrapper = styled(({ className, ...props }) => (
  <Tooltip
    {...props}
    PopperProps={{
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [0, 8],
          },
        },
      ],
    }}
    classes={{ popper: className }}
  />
))(
  () => `
  & .${tooltipClasses.tooltip} {
    background-color: #EFEFEF;
    color: #000;
    font-size: 12px;
    padding-left: 100px;
    font-weight: 400;
    padding: 2px 8px;
    border-radius: 2px;
    box-shadow: 0px 0px 12 px 0pxrgba(0, 0, 0, 0.51)
  }`
)
*/
